/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_BottomInputs */

const en_ocr_crop_bottom = /** @type {(inputs: Ocr_Crop_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom (%)`)
};

const fr_ocr_crop_bottom = /** @type {(inputs: Ocr_Crop_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bas (%)`)
};

const de_ocr_crop_bottom = /** @type {(inputs: Ocr_Crop_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unten (%)`)
};

const it_ocr_crop_bottom = /** @type {(inputs: Ocr_Crop_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metter il fondo a (%)`)
};

const ru_ocr_crop_bottom = /** @type {(inputs: Ocr_Crop_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нижний (%)`)
};

const es_ocr_crop_bottom = /** @type {(inputs: Ocr_Crop_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abajo (%)`)
};

const zh_cn2_ocr_crop_bottom = /** @type {(inputs: Ocr_Crop_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`底部 （％）`)
};

const ja_ocr_crop_bottom = /** @type {(inputs: Ocr_Crop_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`底 （％）`)
};

const hi_ocr_crop_bottom = /** @type {(inputs: Ocr_Crop_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तल (%)`)
};

const pt_pt2_ocr_crop_bottom = /** @type {(inputs: Ocr_Crop_BottomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundo (%)`)
};

/**
* | output |
* | --- |
* | "Bottom (%)" |
*
* @param {Ocr_Crop_BottomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_bottom = /** @type {((inputs?: Ocr_Crop_BottomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_BottomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_crop_bottom(inputs)
	if (locale === "de") return de_ocr_crop_bottom(inputs)
	if (locale === "it") return it_ocr_crop_bottom(inputs)
	if (locale === "ru") return ru_ocr_crop_bottom(inputs)
	if (locale === "es") return es_ocr_crop_bottom(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_crop_bottom(inputs)
	if (locale === "ja") return ja_ocr_crop_bottom(inputs)
	if (locale === "hi") return hi_ocr_crop_bottom(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_crop_bottom(inputs)
	return en_ocr_crop_bottom(inputs)
});